// utils/regionLabel.ts
// Region display name in the UI language (astriaHome.regionName.* keys).
import type { TFunction } from "i18next";
import { ALL_REGIONS_VALUE } from "./regions";

export const regionLabel = (t: TFunction, value: string): string =>
  value === ALL_REGIONS_VALUE
    ? t("region.all")
    : t(`astriaHome.regionName.${value}`, { defaultValue: value });
